import _regeneratorRuntime from "C:/Users/hujun/Desktop/front-end/GLP-PC/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "C:/Users/hujun/Desktop/front-end/GLP-PC/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "C:/Users/hujun/Desktop/front-end/GLP-PC/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.push.js";
import request from "@/utils/request";
import { officialList } from "@/api";
import { mapMutations } from "vuex";
export default {
  data: function data() {
    return {
      questionList: []
    };
  },
  methods: _objectSpread(_objectSpread({}, mapMutations(["UPDATE_SEARCH_VALUE"])), {}, {
    queryOfficialList: function queryOfficialList() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var params, res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              params = {
                pageNum: 1,
                pageSize: 6,
                catCodes: "meet_professor"
              };
              _context.next = 3;
              return request.get(officialList, {
                params: params
              });
            case 3:
              res = _context.sent;
              if (!(res.code != 0 || !res.obj)) {
                _context.next = 6;
                break;
              }
              return _context.abrupt("return");
            case 6:
              _this.questionList = res.obj.rows || [];
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    handleClick: function handleClick(title) {
      this.UPDATE_SEARCH_VALUE(title);
      this.$router.push("/expertAnswer");
    }
  }),
  mounted: function mounted() {
    this.queryOfficialList();
  }
};